import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextInput } from '../../../../../common/inputs/textInput/TextInput'
import ScoutText from '../../../../../common/display/scoutText/ScoutText'
import { FieldProps } from '../../../../../../@types/types'
import { useIsRequiredProperty } from '../../../../../../services/validation/requiredFieldsUtils/useIsRequiredProperty'
import { isWebView } from '../../../../../../utils/navigation'

export type AdTitleValidationResult = {
  adTitle?: string[]
}
export type AdTitleFieldProps = {
  showTitleSubtitle?: boolean
  onHandleTitleChange?: () => false | { type: string }
}
export const AdTitle: React.FC<FieldProps<AdTitleValidationResult> & AdTitleFieldProps> = ({
  insertionData,
  validationMessages,
  screenName,
  showTitleSubtitle,
  onChange,
  onHandleTitleChange,
}) => {
  const { t } = useTranslation()
  const isFieldMandatory = useIsRequiredProperty('adTitle')
  const isWebViewEnabled = isWebView()
  const titleLabel = isWebViewEnabled
    ? t('wizard.screen.description.mobile.adTitle')
    : t('wizard.screen.description.adTitle')

  return (
    <div className='grid-item one-whole'>
      <TextInput
        id='ad-title'
        propertyName='adTitle'
        label={
          showTitleSubtitle ? (
            <ScoutText labelClass={isFieldMandatory ? 'mandatory' : ''} label={titleLabel} />
          ) : (
            <span>{titleLabel}</span>
          )
        }
        value={insertionData.adTitle}
        type='text'
        maxLength={100}
        showMaxLengthLabel={true}
        errors={validationMessages!.adTitle ?? []}
        hideMandatorySign={showTitleSubtitle}
        doOnFieldChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
          onHandleTitleChange && onHandleTitleChange()
        }}
        dataHeyimmoContext='listing_title'
      />
    </div>
  )
}
